import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, NgModule, OnInit } from '@angular/core';
import { DeviceOrientationEnum, FilesService, PlatformService, ScreenService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { TranslateModule } from '@ngx-translate/core';
import { RatingComponent } from '@shared/rating/rating.component';
import { CSchool } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiCoverModule } from 'onclass-ui';
import { OnUiCover } from 'onclass-ui/lib/modules/on-ui-cover/on-ui-cover.component';

@Component({
  selector: 'app-school-header-details',
  templateUrl: './school-header-details.component.html',
  styleUrls: ['../../styles/header-details.scss'],
})
export class SchoolHeaderDetailsComponent extends ChangableComponent implements OnInit {
  @Input() set school(value) {
    this._school = value;
    this.prepareSchooldCard();
  }

  public get school() {
    return this._school;
  }

  public statsStudentsCount = 0;
  public _school: CSchool;

  public constructor(
    protected screenService: ScreenService,
    public deviceService: DeviceDetectorService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
  ) {
    super(cdr, platform);
  }

  public ngOnInit() {}

  private prepareSchooldCard() {
    this.statsStudentsCount = this.school.participants.length;
  }

  public screenClasses() {
    const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
    return {
      tablet: this.deviceService.isTablet(),
      mobile: this.deviceService.isMobile(),
      desktop: (!this.deviceService.isTablet() && !this.deviceService.isMobile()) || this.deviceService.isDesktop(),
      portrait: !this.deviceService.isDesktop() && isPortrait,
      landscape: !this.deviceService.isDesktop() && !isPortrait,
    };
  }

  public get cover(): OnUiCover {
    if (this.school) {
      return {
        type: 'avatar',
        img: FilesService.getFileUrlBySize(this.school.cover_id),
        title: this.title,
      };
    } else {
      return {
        type: 'avatar',
        img: this.assetsUrl('/assets/onclass-logo.svg'),
        title: '',
      };
    }
  }

  public get title(): string {
    return this.school?.title;
  }
}

@NgModule({
  declarations: [SchoolHeaderDetailsComponent],
  imports: [CommonModule, OnUiCoverModule, TranslateModule, RatingComponent],
  exports: [SchoolHeaderDetailsComponent],
})
export class SchoolHeaderDetailsModule {}
